@if (print && filter) {
<app-print-filter-data [filter]="filter" />
} @if (dataMeter) {

<div class="card">
  <p class="title">{{ title }}</p>

  <hr />

  <div class="content">
    <app-cards-weight [dataMeter]="dataMeter" [print]="print" />
    <div class="gauge">
      <app-gauge-chart
        [percentage]="dataMeter.measurmentPercentage"
        responses="{{ dataMeter.responseCount }} respostas {{
          filter!.startDate | date : 'MMM yy'
        }} - {{ filter!.finishDate | date : 'MMM yy' }}"
      />
    </div>
  </div>
</div>

} @if(dataEvolution) {
<app-line-chart [labels]="dataEvolution.labels" [datasets]="dataEvolution" />
}
